import store from '../redux/store';
import axios from 'axios';
import Cookies from 'js-cookie';
import { resetRoom } from '../redux/slicers/roomSlice';
import { resetArea } from '../redux/slicers/areaSlice';
import { resetEvents } from '../redux/slicers/eventsSlice';
import { resetTrends } from '../redux/slicers/trendsSlice';
import { resetZone } from '../redux/slicers/zoneSlice';
import { deSelectClient, deSelectSite } from '../redux/slicers/tenancySlice';
import { setTenancyStatus } from '../redux/slicers/authenticationSlice';
import { resetDevices } from '../redux/slicers/devicesSlice';

export function userLogout(withRedirect: boolean = true): void {
	store.dispatch({ type: 'reset-state' });
	axios.defaults.headers.common['Authorization'] = '';
	Cookies.remove('Global-Token');
	Cookies.remove('Token');
	localStorage.removeItem('clientId');
	localStorage.removeItem('siteId');
	if (withRedirect) {
		window.history.pushState({}, '', '/login');
	}
}

export function clientSiteDataReset(withRedirect: boolean = true): void {
	store.dispatch(resetArea());
	store.dispatch(resetRoom());
	store.dispatch(resetZone());
	store.dispatch(resetDevices());
	store.dispatch(resetEvents());
	store.dispatch(resetTrends());
	Cookies.remove('Token');
	const token = Cookies.get('Global-Token');
	if (token) {
		const parsedToken = JSON.parse(token);
		axios.defaults.headers.common['Authorization'] = parsedToken.token;
	}
	store.dispatch(deSelectClient());
	store.dispatch(deSelectSite());
	store.dispatch(setTenancyStatus(false));
	localStorage.removeItem('clientId');
	localStorage.removeItem('siteId');
	if (withRedirect) {
		window.history.pushState({}, '', '/tenancy');
	}
}
